"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.ShipStatus;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.oxygen);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.power);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.jump);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        oxygen: messageWriter_sidecar_1.messageWriter.readFloat(m),
        power: messageWriter_sidecar_1.messageWriter.readFloat(m),
        jump: messageWriter_sidecar_1.messageWriter.readFloat(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        oxygen: 120.123,
        power: 110.25,
        jump: 254.23,
    };
    messageWriter_sidecar_1.messageWriter.test('ship-status', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    voyageGameStatus_sidecar_1.voyageGameStatus.networkUpdate(msg);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
